import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingHorizontalL,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap' as const,
  },
  header: {
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground1,
  },
  searchInput: {
    minWidth: '240px',
  },
  matchCount: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    padding: `${tokens.spacingVerticalXS} 0`,
    cursor: 'pointer',
    userSelect: 'none' as const,
    border: 'none',
    backgroundColor: 'transparent',
    fontFamily: 'inherit',
    width: '100%',
  },
  groupTitle: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground1,
  },
  flagTable: {
    width: '100%',
    borderCollapse: 'collapse' as const,
  },
  flagRow: {
    display: 'flex',
    alignItems: 'center',
    padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalS}`,
    gap: tokens.spacingHorizontalS,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    fontSize: tokens.fontSizeBase200,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  flagKey: {
    flex: 1,
    fontFamily: 'monospace',
    color: tokens.colorNeutralForeground1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  flagValue: {
    minWidth: '80px',
    textAlign: 'right' as const,
    fontFamily: 'monospace',
  },
  flagTrue: {
    color: tokens.colorPaletteGreenForeground1,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
  },
  flagFalse: {
    color: tokens.colorPaletteRedForeground1,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
  },
  flagOther: {
    color: tokens.colorNeutralForeground2,
  },
  copyBtn: {
    minWidth: 'auto',
    padding: '2px',
    flexShrink: 0,
  },
  emptyState: {
    padding: tokens.spacingVerticalL,
    textAlign: 'center' as const,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
  },
});
